import { RouteObject } from "react-router-dom";

import { error } from "./error";
import { index } from "./index/index";
import { intelligentCreation } from "./intelligent-creation";
import { login } from "./login";
import mobile from "./mobile";
import { reviewTestPaper } from "./review-test-paper";

const routes: RouteObject[] = [
  index,
  ...login,
  error,
  reviewTestPaper,
  ...mobile,
];

export default routes;
